import React, { useState } from 'react'
import { Button } from '../ui/button'
import { CheckIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/16/solid'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import useConfirmTodo from '@/services/api/to-do/useConfirmTodo'

export default function ConfirmButton({ id }: { id: number }) {
  const [open, setOpen] = useState(false)
  const { action: confirmTodo, status } = useConfirmTodo({ id })

  async function confirm() {
    await confirmTodo()
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button iconOnly variant="ghost" title="Confirm">
          <CheckIcon />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Money Path Transfer</DialogTitle>
          <DialogClose>
            <XMarkIcon />
          </DialogClose>
        </DialogHeader>

        <DialogBody>
          <p>Are you sure, you want to confirm?</p>
        </DialogBody>

        <DialogFooter>
          <Button
            type="button"
            variant="default"
            onClick={confirm}
            loading={status.status === 'pending'}
          >
            Yes
          </Button>

          <DialogClose asChild>
            <Button type="button" variant="secondary">
              No
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
